/* ============================================================
   CRISTAL ANTIGUO — SHOPIFY THEME JS
   ============================================================ */

/* ── Utilities ─────────────────────────────────────────────── */
function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2).replace('.', ',');
  return amount + ' €';
}

/* ── CartPanel ──────────────────────────────────────────────── */
class CartPanel {
  constructor() {
    this.panel = document.querySelector('.cart-panel');
    this.overlay = document.querySelector('.cart-overlay');
    this.countEls = document.querySelectorAll('.cristal-cart-count');

    if (!this.panel) return;

    this.labels = {
      title: this.panel.dataset.title || 'Carrito',
      emptyMessage: this.panel.dataset.emptyMessage || 'Tu carrito está vacío.',
      continueShoppingText: this.panel.dataset.continueShoppingText || 'Seguir comprando',
      continueShoppingUrl: this.panel.dataset.continueShoppingUrl || '/collections/all',
      checkoutText: this.panel.dataset.checkoutText || 'Ir al pago',
    };

    // Texto del banner (announcement) para mostrarlo dentro del carrito.
    const annTpl = document.getElementById('cart-announcement-tpl');
    this.announcementHtml = annTpl ? annTpl.innerHTML.trim() : '';

    this.bindEvents();
    this.refreshCart();
  }

  bindEvents() {
    document.querySelectorAll('[data-cart-open], .cart-trigger').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    const closeBtn = this.panel.querySelector('.cart-panel__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-add-to-cart-form]');
      if (!form) return;
      e.preventDefault();
      this.addItem(form);
    });
  }

  open() {
    this.panel.classList.add('cart-panel--open');
    if (this.overlay) this.overlay.classList.add('cart-overlay--open');
    document.body.style.overflow = 'hidden';
    this.refreshCart();
  }

  close() {
    this.panel.classList.remove('cart-panel--open');
    if (this.overlay) this.overlay.classList.remove('cart-overlay--open');
    document.body.style.overflow = '';
  }

  async addItem(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    const originalLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Añadiendo…';
    }

    const data = new FormData(form);
    const body = {
      id: data.get('id'),
      quantity: parseInt(data.get('quantity') || 1, 10),
    };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('Error adding to cart');
      await this.refreshCart();
      this.open();
    } catch (err) {
      console.error('[CartPanel] addItem error:', err);
    } finally {
      // Siempre restaurar el botón (antes se quedaba en «Añadiendo…» al cerrar).
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel || 'Añadir al carrito';
      }
    }
  }

  async refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      this.renderCart(cart);
      if (this.countEls.length) {
        const countText = cart.item_count > 0 ? ` (${cart.item_count})` : '';
        this.countEls.forEach((el) => { el.textContent = countText; });
      }
    } catch (err) {
      console.error('[CartPanel] refreshCart error:', err);
    }
  }

  renderCart(cart) {
    const body = this.panel.querySelector('.cart-panel__body') || this.panel;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <h2 class="cart-panel__title">${this.labels.title}</h2>
        <p class="cart-panel__empty">${this.labels.emptyMessage}</p>
        <a href="${this.labels.continueShoppingUrl}" class="button-cristal cart-panel__keep-shopping--empty" style="display:block;text-align:center;width:100%;margin-top:0;">
          ${this.labels.continueShoppingText}
        </a>
      `;
      return;
    }

    const itemsHtml = cart.items.map(item => `
      <li class="cart-panel__item" data-key="${item.key}">
        <div class="cart-panel__item-main">
          ${item.image ? `<img class="cart-panel__thumb" src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
          <div class="cart-panel__item-meta">
            <div class="cart-panel__item-header">
              <p class="cart-panel__item-title">${item.product_title}</p>
              <p class="cart-panel__item-price">${formatMoney(item.price)}${item.unit_price_measurement && item.unit_price_measurement.quantity_value > 1 ? ' /set de ' + Math.floor(item.unit_price_measurement.quantity_value) : ''}</p>
            </div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-panel__item-variant">${item.variant_title}</p>` : ''}
            <div class="cart-panel__item-actions">
              <input class="cart-panel__qty-input" type="number" min="1" value="${item.quantity}" data-key="${item.key}" aria-label="Cantidad de ${item.product_title}">
            </div>
            <button class="cart-panel__remove" data-key="${item.key}" aria-label="Quitar ${item.product_title}">Quitar</button>
          </div>
        </div>
      </li>
    `).join('');

    body.innerHTML = `
      <h2 class="cart-panel__title">${this.labels.title}</h2>
      <ul class="cart-panel__list" aria-label="Productos en el carrito">${itemsHtml}</ul>
      <div class="cart-panel__total">
        <span>Total</span>
        <span>${formatMoney(cart.total_price)}</span>
      </div>
      <a href="${this.labels.continueShoppingUrl}" class="cart-panel__keep-shopping">${this.labels.continueShoppingText}</a>
      <div class="cart-panel__checkout-group">
        ${this.announcementHtml ? `<div class="cart-panel__announcement archivo-richtext">${this.announcementHtml}</div>` : ''}
        <a href="/checkout" class="button-cristal cart-panel__checkout" style="display:block;text-align:center;width:100%;margin-top:var(--space-s);">
          ${this.labels.checkoutText}
        </a>
      </div>
      <p class="cart-panel__checkout-note caption">Pago seguro con Shopify</p>
    `;

    body.querySelectorAll('.cart-panel__remove').forEach(btn => {
      btn.addEventListener('click', () => this.removeItem(btn.dataset.key));
    });

    body.querySelectorAll('.cart-panel__qty-input').forEach(input => {
      input.addEventListener('change', () => {
        const qty = Math.max(1, parseInt(input.value, 10) || 1);
        this.updateQuantity(input.dataset.key, qty);
      });
    });
  }

  async updateQuantity(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await this.refreshCart();
    } catch (err) {
      console.error('[CartPanel] updateQuantity error:', err);
    }
  }

  async removeItem(key) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      await this.refreshCart();
    } catch (err) {
      console.error('[CartPanel] removeItem error:', err);
    }
  }
}

/* ── NewsletterPanel ────────────────────────────────────────── */
class NewsletterPanel {
  constructor() {
    this.panel = document.querySelector('.newsletter-panel');
    this.overlay = document.querySelector('.newsletter-overlay');
    if (!this.panel) return;

    this.form = this.panel.querySelector('form');
    this.bindEvents();

    // Tras enviar el formulario nativo, Shopify recarga: si hay mensaje de
    // éxito/error reabrimos el panel para que el usuario lo vea.
    if (this.panel.querySelector('.newsletter-form__success, .newsletter-form__error')) {
      this.open();
    }
  }

  bindEvents() {
    const closeBtn = this.panel.querySelector('.newsletter-panel__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.newsletter-trigger, [data-newsletter-open]');
      if (!trigger) return;
      e.preventDefault();
      this.open();
    });

    document.addEventListener('click', (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      // Cubre #newsletter, /newsletter y /pages/newsletter (el panel sustituye
      // a la página: el original redirige /newsletter → / y abre el panel).
      const isNewsletter =
        href === '#newsletter' || href.endsWith('#newsletter') ||
        href === '/newsletter' || href.endsWith('/newsletter') ||
        href.endsWith('/pages/newsletter');
      if (isNewsletter) {
        e.preventDefault();
        this.open();
      }
    });
  }

  open() {
    this.panel.classList.add('newsletter-panel--open');
    if (this.overlay) this.overlay.classList.add('newsletter-overlay--open');
  }

  close() {
    this.panel.classList.remove('newsletter-panel--open');
    if (this.overlay) this.overlay.classList.remove('newsletter-overlay--open');
  }
}

/* ── AnnouncementBar ────────────────────────────────────────── */
class AnnouncementBar {
  constructor() {
    this.bar = document.querySelector('.cristal-announcement-bar');
    const root = document.documentElement;

    if (!this.bar) {
      root.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    if (sessionStorage.getItem('announcement_closed') === '1') {
      this.bar.style.display = 'none';
      root.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    const updateHeight = () => {
      root.style.setProperty('--announcement-bar-height', this.bar.offsetHeight + 'px');
    };

    updateHeight();

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateHeight).observe(this.bar);
    }

    const closeBtn = this.bar.querySelector('.cristal-announcement-bar__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        sessionStorage.setItem('announcement_closed', '1');
        this.bar.style.display = 'none';
        root.style.setProperty('--announcement-bar-height', '0px');
      });
    }
  }
}

/* ── PopupBanner ────────────────────────────────────────────── */
class PopupBanner {
  constructor() {
    this.overlay = document.getElementById('popup-overlay');
    this.banner = document.getElementById('popup-banner');
    if (!this.banner) return;

    const dias = parseInt(this.banner.dataset.popupDias || '7', 10);
    const delayMs = parseInt(this.banner.dataset.popupDelay || '3', 10) * 1000;
    const STORAGE_KEY = 'ca_popup_last_shown';

    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const last = parseInt(raw, 10);
      const daysSince = (Date.now() - last) / (1000 * 60 * 60 * 24);
      if (daysSince < dias) return;
    }

    const closeBtn = this.banner.querySelector('.popup-banner__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    window.setTimeout(() => this.show(), Math.max(0, delayMs));
  }

  show() {
    if (this.overlay) {
      this.overlay.hidden = false;
      this.overlay.classList.add('popup-overlay--open');
    }
    if (this.banner) {
      this.banner.hidden = false;
      this.banner.classList.add('popup-banner--open');
    }
    document.body.style.overflow = 'hidden';
  }

  close() {
    localStorage.setItem('ca_popup_last_shown', String(Date.now()));
    if (this.overlay) {
      this.overlay.classList.remove('popup-overlay--open');
      this.overlay.hidden = true;
    }
    if (this.banner) {
      this.banner.classList.remove('popup-banner--open');
      this.banner.hidden = true;
    }
    document.body.style.overflow = '';
  }
}

/* ── CookieBanner ───────────────────────────────────────────── */
class CookieBanner {
  constructor() {
    this.CONSENT_VERSION = 2;
    this.COOKIE_NAME = 'ca_cookie_consent';

    this.banner = document.querySelector('.cristal-cookie-banner');
    if (!this.banner) return;

    this.bannerView = this.banner.querySelector('.cristal-cookie-banner__main');
    this.prefsView = this.banner.querySelector('.cristal-cookie-preferences');

    // Siempre enlazamos eventos: el botón «Configurar cookies» del footer debe
    // poder reabrir el panel aunque ya exista consentimiento guardado.
    this.bindEvents();

    const saved = this.readConsent();
    if (saved && saved.version === this.CONSENT_VERSION) {
      this.applyConsent(saved);
      return;
    }

    this.showBanner();
  }

  readConsent() {
    try {
      const val = document.cookie.split('; ').find(r => r.startsWith(this.COOKIE_NAME + '='));
      if (!val) return null;
      return JSON.parse(decodeURIComponent(val.split('=')[1]));
    } catch {
      return null;
    }
  }

  writeConsent(data) {
    const json = encodeURIComponent(JSON.stringify(data));
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = `${this.COOKIE_NAME}=${json}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }

  showBanner() {
    this.banner.classList.add('cristal-cookie-banner--visible');
    if (this.bannerView) this.bannerView.style.display = 'block';
    if (this.prefsView) this.prefsView.style.display = 'none';
  }

  showPreferences() {
    // Pre-rellena los checkboxes con el consentimiento guardado (si lo hay).
    const saved = this.readConsent();
    const analyticsCheck = this.banner.querySelector('[data-cookie-analytics]');
    const marketingCheck = this.banner.querySelector('[data-cookie-marketing]');
    if (analyticsCheck) analyticsCheck.checked = saved ? !!saved.analytics : false;
    if (marketingCheck) marketingCheck.checked = saved ? !!saved.marketing : false;

    if (this.bannerView) this.bannerView.style.display = 'none';
    if (this.prefsView) {
      this.prefsView.style.display = 'block';
      this.prefsView.classList.add('cristal-cookie-preferences--visible');
    }
  }

  openPreferences() {
    this.banner.classList.add('cristal-cookie-banner--visible');
    this.showPreferences();
  }

  hideBanner() {
    this.banner.classList.remove('cristal-cookie-banner--visible');
  }

  bindEvents() {
    // Delegación: los botones «Aceptar/Rechazar todo» existen en las DOS vistas
    // (banner y preferencias), así que no sirve querySelector (solo el primero).
    this.banner.addEventListener('click', (e) => {
      if (e.target.closest('[data-cookie-accept]')) this.acceptAll();
      else if (e.target.closest('[data-cookie-reject]')) this.rejectAll();
      else if (e.target.closest('[data-cookie-configure]')) this.showPreferences();
      else if (e.target.closest('[data-cookie-save]')) this.savePreferences();
    });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-open-cookie-settings]');
      if (!btn) return;
      e.preventDefault();
      this.openPreferences();
    });
  }

  acceptAll() {
    const consent = { version: this.CONSENT_VERSION, analytics: true, marketing: true };
    this.writeConsent(consent);
    this.applyConsent(consent);
    this.hideBanner();
  }

  rejectAll() {
    const consent = { version: this.CONSENT_VERSION, analytics: false, marketing: false };
    this.writeConsent(consent);
    this.applyConsent(consent);
    this.hideBanner();
  }

  savePreferences() {
    const analyticsCheck = this.banner.querySelector('[data-cookie-analytics]');
    const marketingCheck = this.banner.querySelector('[data-cookie-marketing]');
    const consent = {
      version: this.CONSENT_VERSION,
      analytics: analyticsCheck ? analyticsCheck.checked : false,
      marketing: marketingCheck ? marketingCheck.checked : false,
    };
    this.writeConsent(consent);
    this.applyConsent(consent);
    this.hideBanner();
  }

  applyConsent(consent) {
    if (typeof gtag === 'function') {
      gtag('consent', 'update', {
        analytics_storage: consent.analytics ? 'granted' : 'denied',
        ad_storage: consent.marketing ? 'granted' : 'denied',
        ad_user_data: consent.marketing ? 'granted' : 'denied',
        ad_personalization: consent.marketing ? 'granted' : 'denied',
      });
    }

    if (consent.analytics) this.loadGA4();
    if (consent.marketing) this.loadMetaPixel();
  }

  loadGA4() {
    if (window._ga4Loaded) return;
    window._ga4Loaded = true;

    const GA4_ID = document.documentElement.dataset.ga4Id;
    if (!GA4_ID) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    window.gtag = window.gtag || gtag;
    gtag('js', new Date());
    gtag('config', GA4_ID);
  }

  loadMetaPixel() {
    if (window._metaPixelLoaded) return;
    window._metaPixelLoaded = true;

    const PIXEL_ID = document.documentElement.dataset.metaPixelId;
    if (!PIXEL_ID) return;

    !function(f,b,e,v,n,t,s){
      if(f.fbq) return; n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
      n.queue=[]; t=b.createElement(e); t.async=!0;
      t.src=v; s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)
    }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }
}

/* ── Infinite slider helper ─────────────────────────────────── */
function initInfiniteSlider({ track, slideSelector, counterEl, prevBtn, nextBtn, swipeEl }) {
  const origSlides = [...track.querySelectorAll(slideSelector)];
  const total = origSlides.length;
  if (total === 0) return;

  let current = 0;

  if (total > 1) {
    const lastClone = origSlides[total - 1].cloneNode(true);
    const firstClone = origSlides[0].cloneNode(true);
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.setAttribute('aria-hidden', 'true');
    track.insertBefore(lastClone, origSlides[0]);
    track.appendChild(firstClone);
    current = 1;
  }

  function setPos(index, animate) {
    current = index;
    track.style.transition = animate ? '' : 'none';
    track.style.transform = `translateX(-${index * 100}%)`;
    if (counterEl) {
      const real = total > 1 ? ((index - 1 + total) % total) : 0;
      counterEl.textContent = `${real + 1}/${total}`;
    }
  }

  // Init without animation
  setPos(current, false);

  // After wrap-around transition: silently jump to real position
  track.addEventListener('transitionend', () => {
    if (total <= 1) return;
    if (current >= total + 1) {
      setPos(1, false);
      void track.offsetWidth; // force reflow so next transition works
    } else if (current <= 0) {
      setPos(total, false);
      void track.offsetWidth;
    }
  });

  function prev() { setPos(current - 1, true); }
  function next() { setPos(current + 1, true); }

  if (prevBtn) prevBtn.addEventListener('click', prev);
  if (nextBtn) nextBtn.addEventListener('click', next);

  if (swipeEl) {
    let startX = 0;
    swipeEl.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    swipeEl.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) dx < 0 ? next() : prev();
    }, { passive: true });
  }
}

/* ── ProductGallery ─────────────────────────────────────────── */
class ProductGallery {
  constructor(el) {
    const track = el.querySelector('.cristal-product-gallery__track');
    if (!track) return;
    initInfiniteSlider({
      track,
      slideSelector: '.cristal-product-gallery__slide',
      counterEl: el.querySelector('.cristal-product-gallery__counter'),
      prevBtn: el.querySelector('.cristal-product-gallery__nav--prev'),
      nextBtn: el.querySelector('.cristal-product-gallery__nav--next'),
      swipeEl: el,
    });
  }
}

/* ── ArchivoSlider ──────────────────────────────────────────── */
class ArchivoSlider {
  constructor(el) {
    const track = el.querySelector('.archivo-slider__track');
    if (!track) return;
    initInfiniteSlider({
      track,
      slideSelector: '.archivo-slider__slide',
      counterEl: el.querySelector('.archivo-slider__counter'),
      prevBtn: el.querySelector('.archivo-slider__nav--prev'),
      nextBtn: el.querySelector('.archivo-slider__nav--next'),
      swipeEl: el,
    });
  }
}

/* ── Variant selector (product page) ───────────────────────── */
function initVariantSelector() {
  const form = document.querySelector('[data-add-to-cart-form]');
  if (!form) return;

  const selects = form.querySelectorAll('.cristal-variant-select');
  if (!selects.length) return;

  const variantData = JSON.parse(
    document.getElementById('product-variants-json')?.textContent || '[]'
  );

  function findVariant() {
    const selected = Array.from(selects).map(s => s.value);
    return variantData.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
  }

  function updateForm() {
    const variant = findVariant();
    const idInput = form.querySelector('input[name="id"]');
    const submitBtn = form.querySelector('[type="submit"]');
    const priceEl = document.querySelector('.cristal-product-detail__price');

    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Añadir al carrito';
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Vendido';
      }
    }

    if (priceEl) {
      if (variant.available && variant.price != null) {
        const price = (variant.price / 100).toFixed(2).replace('.', ',') + ' €';
        let html = 'Precio: ' + price;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const comparePrice = (variant.compare_at_price / 100).toFixed(2).replace('.', ',') + ' €';
          html += ` <span class="cristal-product-detail__price-compare">${comparePrice}</span>`;
        }
        priceEl.innerHTML = html;
      } else {
        priceEl.innerHTML = '<span class="cristal-product-detail__sold">VENDIDO</span>';
      }
    }
  }

  selects.forEach(s => s.addEventListener('change', updateForm));
}

/* ── Collection filter ──────────────────────────────────────── */
function initCollectionFilter() {
  const filterBtns = document.querySelectorAll('.cristal-filter-btn');
  if (!filterBtns.length) return;

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const categoria = btn.dataset.categoria || '';
      const url = new URL(window.location.href);
      if (categoria) {
        url.searchParams.set('categoria', categoria);
      } else {
        url.searchParams.delete('categoria');
      }
      window.location.href = url.toString();
    });
  });

  const params = new URLSearchParams(window.location.search);
  const active = params.get('categoria') || '';
  filterBtns.forEach(btn => {
    const cat = btn.dataset.categoria || '';
    btn.classList.toggle('cristal-filter-btn--active', cat === active);
  });
}

/* ── Floating logo ──────────────────────────────────────────── */
/* Ancla el logo justo encima del footer (bottom = altura del footer − 40px),
   igual que el componente FloatingLogo del original. */
function initFloatingLogo() {
  const logo = document.querySelector('.cristal-floating-logo');
  const footer = document.querySelector('.cristal-footer');
  if (!logo || !footer) return;

  const update = () => {
    const h = footer.offsetHeight;
    document.documentElement.style.setProperty('--logo-bottom', (h - 40) + 'px');
  };

  update();
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(update).observe(footer);
  }
  window.addEventListener('resize', update);
}

function initHeaderSlots() {
  document.querySelectorAll('.cristal-header-inner').forEach((inner) => {
    const start = inner.querySelector('.cristal-header-slot--start');
    const end = inner.querySelector('.cristal-header-slot--end');
    if (!start || !end) return;

    inner.querySelectorAll('.cristal-header-action').forEach((action) => {
      if (start.contains(action) || end.contains(action)) return;

      const isRight = action.dataset.headerSide === 'right'
        || action.querySelector('.cristal-header-side--end, .cart-trigger.cristal-header-side--end');

      (isRight ? end : start).appendChild(action);
    });
  });
}

/* ── Init ───────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  new AnnouncementBar();
  new CartPanel();
  new NewsletterPanel();
  new PopupBanner();
  new CookieBanner();

  document.querySelectorAll('.cristal-product-gallery').forEach(el => new ProductGallery(el));
  document.querySelectorAll('.archivo-slider').forEach(el => new ArchivoSlider(el));

  initVariantSelector();
  initCollectionFilter();
  initFloatingLogo();
  initHeaderSlots();
});

document.addEventListener('shopify:section:load', (e) => {
  initHeaderSlots(e);
  e.target.querySelectorAll('.archivo-slider').forEach(el => new ArchivoSlider(el));
});
document.addEventListener('shopify:block:select', initHeaderSlots);
